export default "__VITE_ASSET__qvJt0yc9__";